import React from 'react';
import KnotDecoration from '../illustrations/KnotDecoration';

export default function Contact({ onContactClick }) {
  return (
    <section id="contacto" className="section-padding bg-forest relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <svg className="w-full h-full" viewBox="0 0 100 100" preserveAspectRatio="none">
          <pattern id="grid" width="10" height="10" patternUnits="userSpaceOnUse">
            <circle cx="1" cy="1" r="0.5" fill="#F5F0E8" />
          </pattern>
          <rect width="100" height="100" fill="url(#grid)" />
        </svg>
      </div>

      <div className="container-narrow relative z-10">
        <div className="max-w-3xl mx-auto text-center">
          <KnotDecoration size="md" invert className="mx-auto mb-8 opacity-40" />

          <h2 className="text-cream mb-6">¿Damos el primer paso?</h2>

          <p className="text-cream-80 text-lg mb-10 max-w-2xl mx-auto">
            Si sientes que es el momento de cuidarte, de entender lo que te pasa o simplemente
            quieres más información, estaremos encantados de escucharte.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-16">
            <button
              onClick={onContactClick}
              className="btn-primary bg-cream text-forest hover:bg-cream/90"
            >
              Enviar un mensaje
            </button>
            <a
              href="tel:+34626235122"
              className="inline-flex items-center justify-center px-8 py-4 font-medium rounded-full border-2 border-[var(--color-inerva-cream)] text-[var(--color-inerva-cream)] bg-transparent transition-all duration-300 hover:bg-[var(--color-inerva-cream)] hover:text-[var(--color-inerva-forest)] hover:-translate-y-0.5"
            >
              Llamar ahora
            </a>
          </div>

          <div className="grid sm:grid-cols-3 gap-8 pt-10 border-t border-cream/20">
            <div className="text-center">
              <a
                href="tel:+34626235122"
                className="w-12 h-12 mx-auto mb-4 rounded-full bg-cream/10 flex items-center justify-center hover:bg-cream/20 transition-all cursor-pointer"
              >
                <svg className="w-6 h-6 text-cream" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
              </a>
              <div className="text-cream font-medium mb-1">Teléfono</div>
              <a href="tel:+34626235122" className="text-cream-70 hover:text-cream transition-colors">
                626 235 122
              </a>
            </div>

            <div className="text-center">
              <a
                href="mailto:inerva.psicologia@gmail.com"
                className="w-12 h-12 mx-auto mb-4 rounded-full bg-cream/10 flex items-center justify-center hover:bg-cream/20 transition-all cursor-pointer"
              >
                <svg className="w-6 h-6 text-cream" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </a>
              <div className="text-cream font-medium mb-1">Email</div>
              <a href="mailto:inerva.psicologia@gmail.com" className="text-cream-70 hover:text-cream transition-colors text-sm">
                inerva.psicologia@gmail.com
              </a>
            </div>

            <div className="text-center">
              <a
                href="https://www.instagram.com/inerva.psicologia"
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 mx-auto mb-4 rounded-full bg-cream/10 flex items-center justify-center hover:bg-cream/20 transition-all cursor-pointer"
              >
                <svg className="w-6 h-6 text-cream" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                </svg>
              </a>
              <div className="text-cream font-medium mb-1">Instagram</div>
              <a
                href="https://www.instagram.com/inerva.psicologia"
                target="_blank"
                rel="noopener noreferrer"
                className="text-cream-70 hover:text-cream transition-colors text-sm"
              >
                @inerva.psicologia
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
